import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import useHomepage from '../../hooks/useHomepage'
import { Plan as PlanType } from '../../types'
import ScrollAnimation from '../scroll-animation/Container'
import { mealCreditsRangeByCity, mealsRangeCopyVisible, taxCopyVisible } from './helpers'

type Props = {
  plans: PlanType[]
}

const Taxes: React.FC<Props> = ({ plans }) => {
  const { t } = useTranslation()
  const { activeCityName, animationProps } = useHomepage()

  const mealCreditsRange = mealCreditsRangeByCity(activeCityName)

  return (
    <ScrollAnimation {...animationProps}>
      <div className="plans__description">
        {taxCopyVisible(activeCityName) && t('In the U.S. and Canada, tax and fees are additional.')}
        {mealsRangeCopyVisible(plans) && <>&nbsp; {t(`Meals range from ${mealCreditsRange} credits.`)}</>}
      </div>
    </ScrollAnimation>
  )
}

export default Taxes
